module.exports = __webpack_public_path__ + "img/instruction.bb46eb82.png";